import React from 'react';

const MacroNutrients = ({ value, setFieldValue }) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="flex flex-col gap-1">
        <label className="text-[#14151A] text-[14px] font-medium">
          Fat <span className="text-[12px] text-red-500">*</span>
        </label>
        <input
          type="text"
          placeholder="Fat"
          value={value?.fat}
          inputMode="numeric"
          className="border-[1px] border-[#DEE0E3] text-sm font-normal placeholder:text-[#0D112666] rounded-md p-2 w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
          onChange={(e) => {
            const raw = e.target.value;
            const numericOnly = raw.replace(/[^0-9]/g, '');
            setFieldValue('fat', numericOnly === '' ? '' : Number(numericOnly));
          }}
        />
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-[#14151A] text-[14px] font-medium">
          Carbohydrate <span className="text-[12px] text-red-500">*</span>
        </label>
        <input
          type="text"
          required
          placeholder="Carbohydrates"
          value={value?.carbohydrate}
          inputMode="numeric"
          className="border-[1px] border-[#DEE0E3] text-sm font-normal placeholder:text-[#0D112666] rounded-md p-2 w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
          onChange={(e) => {
            const raw = e.target.value;
            const numericOnly = raw.replace(/[^0-9]/g, '');
            setFieldValue(
              'carbohydrate',
              numericOnly === '' ? '' : Number(numericOnly)
            );
          }}
        />
      </div>

      <div className="flex flex-col gap-1">
        <label className="text-[#14151A] text-[14px] font-medium">
          Protein <span className="text-[12px] text-red-500">*</span>
        </label>
        <input
          type="text"
          required
          placeholder="Protein"
          value={value?.protein}
          inputMode="numeric"
          className="border-[1px] border-[#DEE0E3] text-sm font-normal placeholder:text-[#0D112666] rounded-md p-2 w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
          onChange={(e) => {
            const raw = e.target.value;
            const numericOnly = raw.replace(/[^0-9]/g, '');
            setFieldValue('protein', numericOnly === '' ? '' : Number(numericOnly));
          }}
        />
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-[#14151A] text-[14px] font-medium">Fiber</label>
        <input
          type="text"
          placeholder="Fiber"
          value={value?.fiber}
          inputMode="numeric"
          className="border-[1px] border-[#DEE0E3] text-sm font-normal placeholder:text-[#0D112666] rounded-md p-2 w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
          onChange={(e) => {
            const raw = e.target.value;
            const numericOnly = raw.replace(/[^0-9]/g, '');
            setFieldValue('fiber', numericOnly === '' ? '' : Number(numericOnly));
          }}
        />
      </div>
    </div>
  );
};

export default MacroNutrients;
